import React, { useState } from 'react';
import { Handshake, Building2, Crown } from 'lucide-react';
import PartnersManagementPage from './PartnersManagementPage';
import PortfolioManagementPage from './PortfolioManagementPage';
import ExecutiveProfilesPage from './ExecutiveProfilesPage';
import HubShell from '../../components/staff/HubShell';

/**
 * Brand & Team Hub — bundles Affiliates, Portfolio and the public Team Page manager
 * (executive profiles). All three shape the outward-facing Starnight brand.
 */
const BrandTeamHubPage = (props) => {
  const isSuper = props.currentUser?.role === 'superadmin';
  const [tab, setTab] = useState('team');
  const tabs = [
    { id: 'team', label: 'Team Page', icon: Crown, desc: 'Public /team execs & staff', visible: isSuper },
    { id: 'affiliates', label: 'Affiliates', icon: Handshake, desc: 'Partnerships & referrals', visible: isSuper },
    { id: 'portfolio', label: 'Portfolio', icon: Building2, desc: 'Our groups & properties', visible: isSuper },
  ];

  if (!isSuper) {
    return (
      <div className="flex items-center justify-center h-[70vh]" data-testid="brand-hub-denied">
        <div className="text-center">
          <Crown className="w-12 h-12 text-amber-400 mx-auto mb-3" />
          <h2 className="text-xl font-light text-white tracking-tight mb-1">Restricted</h2>
          <p className="text-white/40 text-sm">Only superadmins can manage brand & team pages.</p>
        </div>
      </div>
    );
  }

  return (
    <HubShell
      title="Brand & Team"
      accent="Hub"
      subtitle="Everything the world sees — executives, partners, and portfolio."
      icon={Crown}
      tone="amber"
      tabs={tabs}
      activeTab={tab}
      onTabChange={setTab}
      dataTestId="brand-team-hub"
    >
      {tab === 'team' && <ExecutiveProfilesPage {...props} />}
      {tab === 'affiliates' && <PartnersManagementPage {...props} />}
      {tab === 'portfolio' && <PortfolioManagementPage {...props} />}
    </HubShell>
  );
};

export default BrandTeamHubPage;
